import React, { useState, useEffect, useRef, useImperativeHandle } from "react";
import { Form, Tab } from "@tencent/universe-ui/build/lib";
import Params from './common/Params.jsx';
import { Button, MessagePlugin, Radio, Tooltip } from 'tdesign-react';
import { dealEduAgentRect, dealMarkInfoRect,dealEssayRect } from '../utils/edu.js';
import { baseOcrRequest, addRecentMenu } from '../utils/api.js';
import { DownloadExcel, DownloadMd } from '../utils/index.js';
import { v4 as uuidv4 } from 'uuid';
import { cosUrl, defaultEduAgentImg } from '../const/menuData';
import RspParams from './common/RspParams.jsx';
import useRecursiveAxiosCaller from '../utils/useRecursiveAxiosCaller';
import '../style/GeneralBasicOCR.css'
const reg = /^\s*$/
const defaultRspTabs = [
  {
    id: 'Result',
    label: '识别结果',
    type: 'Result'
  },
  {
    id: 'Request',
    label: 'Request',
    type: 'Request'
  },
  {
    id: 'Response',
    label: 'Response',
    type: 'Response'
  }
]

const maxResultTimes = 60 * 5; // 获取agent结果最大次数
const maxResultGap = 2000;// 获取agent结果间隔时间

/**
 * GeneralBasicOCR组件：通用OCR识别组件，支持同步和异步OCR识别功能。
 * @param {Object} props - 组件属性
 * @param {Object} props.defaultConfig - 默认配置
 * @param {Function} props.selectRect - 选择区域的回调函数
 * @param {Object} props.cRef - 组件引用
 * @param {Object} props.detail - OCR任务详情
 * @param {Object} props.image - 图片信息
 * @param {Function} props.onSelect - 选择回调
 * @param {Function} props.onChangeRequest - 请求参数变更回调
 * @param {Function} props.onChangeImg - 图片变更回调
 * @param {Function} props.onLoading - 加载状态变更回调
 * @param {Function} props.onChangeImageEnhancement - 图片增强回调
 * @param {Function} props.onImageError - 图片错误回调
 * @param {Function} props.onResult - 识别结果回调
 * @param {number} props.totalPage - 总页数
 */
export default function GeneralBasicOCR({ uploadImglist, onAddMenu, clipImg, selectRect, cRef, detail, image, onSelect, onChangeRequest, onChangeImg, onLoading, onChangeImageEnhancement, onImageError, onResult, totalPage = 50 }) {
  useImperativeHandle(cRef, () => ({
    start: ({ image, config }) => {
      const _smartKeyList = smartKeyList.filter(item => !item.isCustom);
      setSmartKeyList(_smartKeyList);
      const _params = {
        ...requestParamsValue,
        ...config
      }
      // 每次重新上传图片，将页码至为初始值
      if (_params.hasOwnProperty('FileEndPageNumber')) {
        _params.FileEndPageNumber = 1
      }
      if (_params.hasOwnProperty('FileStartPageNumber')) {
        _params.FileStartPageNumber = 1
      }
      setParamsValue(_params);
      setRequestParamsValue(_params);
      onChangeRequest && onChangeRequest({ ..._params });
      handleStart({ _params, _image: image, _smartKeyList });
    }
  }));

  const [paramsValue, setParamsValue] = useState({});
  const [requestParamsValue, setRequestParamsValue] = useState({}); //  实际接口调用参数
  const [showParams, setShowParams] = useState(true);
  const [response, setResponse] = useState({});
  const [finalResponse, setFinalResponse] = useState({});
  const [request, setRequest] = useState({});
  const [curColl, setCurColl] = useState('');
  const [smartKeyList, setSmartKeyList] = useState([]);
  const [rspTabs, setRspTabs] = useState(defaultRspTabs);
  const [isLoading, setIsLoading] = useState(false);
  const [isThinking, setIsThinking] = useState(false);
  const [isMarkLoading, setIsMarkLoading] = useState(false); // markEdu 批改结果加载状态
  const [rectOptions, setRectOptions] = useState([]);
  const [apiType, setApiType] = useState("");
  const [paramsList, setParamsList] = useState([]);
  const [eduMarkData, setEduMarkData] = useState(null); // 存储eduAgent的resSubmit数据

  const messagesEnd = useRef(null);
  const paramsRef = useRef(null);

  const {
    start,
    stop,
    on
  } = useRecursiveAxiosCaller(maxResultTimes, maxResultGap, (response) => {
    return response?.JobStatus === 'DONE';
  });


  // 注册事件监听器
  useEffect(() => {
    // 取消监听函数
    const cleanupFns = [];
    // 响应事件监听
    cleanupFns.push(on('onResponse', (response, attempt, log, extraData) => {

      let _finialRes = JSON.parse(JSON.stringify(response));
      delete _finialRes.auditData;
      setResponse(response);
      setFinalResponse(_finialRes);

      if (response?.Error || response?.error || response?.JobStatus === 'FAIL') {
        handleStop();
        setIsThinking(false);
        setIsLoading(false);
        onLoading && onLoading(false);
        MessagePlugin.error({
          content: response.message || response.msg || '识别失败',
          duration: 3000,
          className: 'ocrDemo-messgae-error',
          icon: <span className="ocrDemo-icon-errorMsg"></span>
        })
      }
    }));

    // 完成事件监听
    cleanupFns.push(on('onComplete', (result, reason, log, extraData) => {
      let message = '';
      handleStop();
      console.log('onComplete',result)
      switch (reason) {
        case 'completed':
          successHandler(result, extraData);
          setIsThinking(false);
          setIsMarkLoading(false);
          message = `调用成功完成: ID ${result}`;
          break;
        case 'stopped':
          setIsLoading(false);
          onLoading && onLoading(false);
          setIsThinking(false);
          setIsMarkLoading(false);
          message = '调用被手动停止';
          break;
        case 'max_attempts': // '达到最大尝试次数';
        case 'error':
          setIsLoading(false);
          onLoading && onLoading(false);
          setIsThinking(false);
          setIsMarkLoading(false);
          MessagePlugin.error({
            content: result?.message || result?.msg || '识别失败',
            duration: 3000,
            className: 'ocrDemo-messgae-error',
            icon: <span className="ocrDemo-icon-errorMsg"></span>
          })
          message = '调用过程中出错';
          break;
        default:
          setIsLoading(false);
          onLoading && onLoading(false);
          setIsThinking(false);
          setIsMarkLoading(false);

          message = `调用完成: ${reason}`;
      }
    }));

    // 组件卸载时取消所有监听
    return () => cleanupFns.forEach(fn => fn());
  }, [on]);

  const scrollToBottom = () => {
    if (messagesEnd && messagesEnd.current) {
      messagesEnd.current.scrollIntoView({ behavior: 'smooth', block: "end", inline: "nearest" });
    }
  };


  useEffect(() => {
    if (smartKeyList?.length > 0) {
      scrollToBottom();
    }
  }, [smartKeyList]);

  useEffect(() => {
    //  切换题目自动识别
    if (clipImg) {
      handleStartEduAgent({ clipImg });
    }
  }, [clipImg]);



  /**
   * 重置参数到默认值
   */
  const handleResetParams = () => {
    // const _value = {};
    // if (paramsList?.length > 0) {
    //   paramsList.forEach(e => {
    //     _value[e.key] = JSON.parse(JSON.stringify(e.default));
    //   });
    // }
    handleStop();
    setParamsAndValue(detail.defaultApi,false,false);
    // setParamsValue({ ..._value });
    // setRequestParamsValue({ ..._value });
    // onChangeRequest && onChangeRequest({ ..._value });
    setSmartKeyList([]);
    if (detail.actionType === 'eduAgent' && rectOptions.length > 0) {
      onSelect(rectOptions[0].label, rectOptions[0].key, rectOptions[0])
    }
  }



  const setParamsAndValue = (apitype,startImmediately = true,keepOldVal = false) => {
    const _value = {};
    let _paramsList = [];
    let _tab = detail.config?.Tabs || defaultRspTabs;
    setApiType(apitype);
    if (apitype === 'sync' && detail.syncConfig) {
      _paramsList = detail.syncConfig.paramsList;
      _tab = detail.syncConfig.Tabs || defaultRspTabs;
    } else if (apitype === 'async' && detail.asyncConfig) {
      _paramsList = detail.asyncConfig.paramsList;
    } else {
      _paramsList = detail.paramsList;
    }

    setParamsList(_paramsList);
    if (_paramsList?.length > 0) {
      _paramsList.forEach(e => {
        // 检查旧的paramsValue中是否已经有这个键，如果有就保留旧值，否则使用默认值
        if (paramsValue.hasOwnProperty(e.key) && keepOldVal) {
          _value[e.key] = paramsValue[e.key];
        } else {
          _value[e.key] = JSON.parse(JSON.stringify(e.default));
        }
      });
    }

    setParamsValue({ ..._value });
    setRequestParamsValue({ ..._value });
    setRspTabs(_tab)
    setCurColl(_tab[0].id);
    if(startImmediately){
      onChangeRequest && onChangeRequest({ ..._value });
      handleStart({ _params: _value, _image: image, _smartKeyList: [],_apiType:apitype  });
    }
  }

  useEffect(() => {
    if (!detail) return;
    setResponse({});
    setFinalResponse({});
    setRequest({});
    setParamsAndValue(detail.defaultApi,true,false);
    setSmartKeyList([]);
  }, [detail]);

  const successHandler = (res, extra) => {
    handleStop();
    let _finialRes = JSON.parse(JSON.stringify(res));
    delete _finialRes.auditData;
    setResponse(res);
    setFinalResponse(_finialRes);
    let rect = [];
    const pdfNum = extra.pdfNum;
    if(extra.config.actionType === 'markEdu'){
      let rect1 = dealEduAgentRect(extra.resSubmit, false, pdfNum)
      // 使用 dealMarkInfoRect 处理 MarkInfos 的坐标，生成子题目矩形框
      let rect2 = dealMarkInfoRect(res, extra.resSubmit, pdfNum);
      rect = [...rect1, ...rect2]
      if(rect.length > 0 && rect[0]){
        onSelect(rect[0].label, rect[0].key, rect[0])
      }
    }else if(extra.config.resultConfig.type === 'essayEdu'){
      rect = dealEssayRect(res, 0, 0, pdfNum);
    }
    console.log('dealEssayRect rect',rect)
    onResult && onResult({
      uploadImglist: extra.uploadImglist,
      config: extra.config,
      ...extra.requestParams,
      rect,
      rsp: {
        ...res,
        auditData: extra.auditData
      }
    });
    onLoading && onLoading(false);
    setIsLoading(false);
  }
  const errorHandler = (res, extra) => {
    MessagePlugin.error({
      content: res.message || res.msg || '识别失败',
      duration: 3000,
      className: 'ocrDemo-messgae-error',
      icon: <span className="ocrDemo-icon-errorMsg"></span>
    })
    setResponse(res);
    let _finialRes = JSON.parse(JSON.stringify(res));
    delete _finialRes.auditData;
    setFinalResponse(_finialRes);
    onResult && onResult({
      uploadImglist: extra.uploadImglist,
      isError: true,
      config: extra.config,
      ...extra.requestParams,
      rsp: {
        ...res,
        auditData: extra.auditData
      }
    });
    setIsLoading(false);
    onLoading && onLoading(false);
    setIsThinking(false);
  }

  const handleStop = async () => {
    stop();
  }

  const handleAddRecentMenu = async (InterfaceName) => {
    try {
      const res = await addRecentMenu({
        InterfaceName: InterfaceName
      })
      if (!res.error) {
        onAddMenu && onAddMenu(InterfaceName)
      }
    } catch (e) {
      console.log('handleAddRecentMenu', e)
    }

  }

  const handleStartEduAgent = async ({ clipImg = clipImg }) => {
    if (!clipImg) return;
    setIsThinking(true);
    setResponse({});
    setFinalResponse({});
    setRequest({});
    const payload = {
      ImageBase64: clipImg.img
      // ImageBase64:clipImg.img.replace('data:image/png;base64,', '')
    }
    const res = await baseOcrRequest({
      cmd: detail.actionList[1],
      data: payload,
      isExample: defaultEduAgentImg === clipImg.img, //  查询default
      fileType: 'png',
      module: detail.module || 'ocr'
    })
    // const res = await markRes.data.Response ;
    handleAddRecentMenu(detail.actionList[1])
    setIsThinking(false);
    setRequest({ ...payload });
    if (res.error) {
      MessagePlugin.error({
        content: res.message || res.msg || '识别失败',
        duration: 3000,
        className: 'ocrDemo-messgae-error',
        icon: <span className="ocrDemo-icon-errorMsg"></span>
      })
      setResponse(res);
      let _finialRes = JSON.parse(JSON.stringify(res));
      delete _finialRes.auditData;
      setFinalResponse(_finialRes);
    } else {
      let _finialRes = JSON.parse(JSON.stringify(res));
      delete _finialRes.auditData;
      setResponse(res);
      setFinalResponse(_finialRes);
    }
  }

  /**
   * 处理开始OCR识别的逻辑
   * @param {Object} options - 参数对象
   * @param {Object} options._params - 请求参数
   * @param {Object} options._image - 图片信息
   * @param {Array} options._smartKeyList - 智能结构化字段列表
   * @param {Object} options.config - 配置信息
   */
  const handleStart = async ({ _params = requestParamsValue, _image = image, _smartKeyList = smartKeyList ,_apiType = apiType} = {}) => {
    // return
    if (!_image) return;
    if (!validate(_smartKeyList)) return;
    // 每次发起请求删除上次的记录
    handleStop();
    setResponse({});
    setFinalResponse({});
    setRequest({});
    let config = {
      ...detail,
    };
    if (_apiType === 'sync' && detail.syncConfig) {
      config = {
        ...detail,
        ...detail.syncConfig
      }
    } else if (_apiType === 'async' && detail.asyncConfig) {
      config = {
        ...detail,
        ...detail.asyncConfig
      }
    } else {
      config = {
        ...detail,
        ...detail.asyncConfig
      }
    }
    if (config?.showCustomItem || config.resultConfig?.showCustomItem) {
      if (_smartKeyList?.length > 0) {
        _params.ItemNames = _smartKeyList.map(i => {
          return i.isCustom ? detail.options[i.value] : i.value
        }).filter(n => n);
      } else {
        _params.ItemNames = []
      }
    }

    
    if (config.actionType === 'eduAgent') {
      setIsLoading(true);
      onLoading && onLoading(true);
      setRectOptions([]);
      let payload = JSON.parse(JSON.stringify(config.actionList[0].params))
      const resSubmit = await baseOcrRequest({
        cmd: config.actionList[0].action,
        data: { ...payload, [_image.prefix]: _image.param ? _image.param : _image.url },
        isExample: _image.isExample,
        fileType: _image.fileType,
        module: config.module || 'ocr'
      })
      handleAddRecentMenu(config.actionList[1])
      if (resSubmit.isImageError) {
        onImageError(true);
      } else {
        onImageError(false);
      }
      if (resSubmit.error) {
        setIsLoading(false);
        onLoading && onLoading(false);
        errorHandler(resSubmit, {
          uploadImglist: uploadImglist,
          config: {
            ...detail,
            action: detail.actionList[0].action
          },
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          auditData: resSubmit.auditData
        });
        setRequest({ ..._params, [_image.prefix]: _image.url });
      } else {
        let rect = dealEduAgentRect(resSubmit, true, _params.PdfPageNumber)
        setRectOptions(rect);
        setEduMarkData(resSubmit); // 存储resSubmit数据
        setIsLoading(false);
        onLoading && onLoading(false);
        onResult && onResult({
          uploadImglist: uploadImglist,
          config: {
            ...detail,
            action: detail.actionList[0].action
          },
          image: _image,
          requestParams: _params,
          rsp: resSubmit,
          select: rect,
          rect: rect
        });
      }
    } else if (config.actionType === 'Async') {
      setIsLoading(true);
      onLoading && onLoading(true);
      let payload = JSON.parse(JSON.stringify(_params))
      if (!payload.PdfPageNumber) {
        delete payload.PdfPageNumber
      }
      // supportImgList
      const dataParams ={
        ...payload
      }
      if(config.supportImgList){
        dataParams[`${_image.prefix}List`] = _image.param ? [_image.param] : [_image.url]
      }else{
        dataParams[`${_image.prefix}`] = _image.param ? _image.param : _image.url
      }
      const resSubmit = await baseOcrRequest({
        cmd: config.actionList[0],
        data: dataParams,
        isExample: _image.isExample,
        fileType: _image.fileType,
        module: config.module || 'ocr'
      })
      handleAddRecentMenu(config.actionList[0])
      if (resSubmit.isImageError) {
        onImageError(true);
      } else {
        onImageError(false);
      }
      const  JobId = config.supportImgList ? resSubmit.JobIds && resSubmit.JobIds[0] : resSubmit.JobId
      if (resSubmit.error || !JobId) {
        setIsLoading(false);
        onLoading && onLoading(false);
        errorHandler(resSubmit, {
          config: config,
          uploadImglist: uploadImglist,
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          auditData: resSubmit.auditData
        });
        setRequest({ ..._params, [_image.prefix]: _image.url });
      } else {
        const payload = {
          cmd: config.actionList[1],
          data: {
            JobId
          },
          isExample: _image.isExample,
          fileType: _image.fileType,
          module: config.module || 'ocr'
        }
        start(payload, {
          config: config,
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          uploadImglist: uploadImglist,  //  异步任务，参数会丢失，需要传递后保存
          auditData: resSubmit.auditData
        });
        setIsLoading(false);
        onLoading && onLoading(false);
        setIsThinking(true);
        setRequest({ ..._params, [_image.prefix]: _image.url });
      }
    }  else if (config.actionType === 'markEdu') {
      let payload = JSON.parse(JSON.stringify(_params))
      if (!payload.PdfPageNumber) {
        delete payload.PdfPageNumber
      }
      const resSubmit = await baseOcrRequest({
        cmd: config.actionList[0],
        data: { ...payload, [_image.prefix]: _image.param ? _image.param : _image.url },
        isExample: _image.isExample,
        fileType: _image.fileType,
        module: config.module || 'ocr'
      })
      setEduMarkData(resSubmit); // 存储resSubmit数据
      handleAddRecentMenu(config.actionList[0])
      if (resSubmit.isImageError) {
        onImageError(true);
      } else {
        onImageError(false);
      }
      if (resSubmit.error || !resSubmit.JobId) {
        setIsLoading(false);
        onLoading && onLoading(false);
        errorHandler(resSubmit, {
          config: config,
          uploadImglist: uploadImglist,
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          auditData: resSubmit.auditData
        });
        setRequest({ ..._params, [_image.prefix]: _image.url });
      } else {
        const payload = {
          cmd: config.actionList[1],
          data: {
            JobId: resSubmit.JobId
          },
          isExample: _image.isExample,
          fileType: _image.fileType,
          module: config.module || 'ocr'
        }
        
        setIsLoading(false);
        onLoading && onLoading(false);
        const rect = dealEduAgentRect(resSubmit, false, _params.PdfPageNumber)
        onResult && onResult({
          uploadImglist: uploadImglist,
          config: {
            ...detail,
            action: detail.actionList[0].action
          },
          image: _image,
          requestParams: _params,
          rsp: resSubmit,
          select: rect,
          rect: rect
        });
        start(payload, {
          config: config,
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          resSubmit:resSubmit,
          uploadImglist: uploadImglist,  //  异步任务，参数会丢失，需要传递后保存
          auditData: resSubmit.auditData,
          pdfNum: _params.PdfPageNumber
        });
        setIsMarkLoading(true); // 开始批改结果加载
        // setIsThinking(true);
        setRequest({ ..._params, [_image.prefix]: _image.url });
      }
    } else {
      setIsLoading(true);
      onLoading && onLoading(true);
      const res = await baseOcrRequest({
        cmd: config.action,
        data: { ..._params, [_image.prefix]: _image.param ? _image.param : _image.url },
        isExample: _image.isExample,
        fileType: _image.fileType,
        module: config.module || 'ocr',
      })
      handleAddRecentMenu(config.action)

      if (res.isImageError) {
        onImageError(true);
      } else {
        onImageError(false);
      }
      setRequest({ ..._params, [_image.prefix]: _image.url });
      if (res.error) {
        errorHandler(res, {
          config: config,
          uploadImglist: uploadImglist,
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          auditData: res.auditData
        });
      } else {
        // 处理智能结构化
        if (config.isImageResult) {
          // 处理文本图像
          const imageField = config.resultConfig?.imageResultField || 'Image';
          onChangeImageEnhancement && onChangeImageEnhancement({
            type: _params.TaskType === 1 ? 'col' : 'split',
            url: res[imageField]
          })
        }
        successHandler(res, {
          config: config,
          requestParams: {
            image: _image,
            requestParams: _params,
          },
          auditData: res.auditData,
          uploadImglist: uploadImglist
        });
      }
    }

  }

  /**
   * 添加智能结构化字段
   * @param {string} type - 字段类型（'custom'或'default'）
   */
  const handleAddSmart = (type) => {
    let _key = uuidv4();
    smartKeyList.push({
      isCustom: type === 'custom' ? false : true,
      showClose: true,
      type: type === 'custom' ? 'input' : 'select',
      key: _key,
      default: '',
      value: '',
      status: ''
    })
    setSmartKeyList([...smartKeyList]);
  }
  /**
   * 删除智能结构化字段
   * @param {Object} params - 字段参数
   * @param {number} index - 字段索引
   */
  const handleDelSmart = (params, index) => {
    smartKeyList.splice(index, 1);
    setSmartKeyList([...smartKeyList]);
  }
  /**
   * 验证智能结构化字段
   * @param {Array} _smartKeyList - 智能结构化字段列表
   * @returns {boolean} 验证结果
   */
  const validate = (_smartKeyList = smartKeyList) => {
    let result = _smartKeyList.map(item => {
      if (reg.test(item.value)) {
        return {
          ...item,
          status: 'error'
        }
      } else {
        return {
          ...item,
          status: ''
        }
      }
    })
    setSmartKeyList([...result]);
    return result.filter(i => i.status == 'error').length > 0 ? false : true
  }
  return (
    <div className="result-panel">
      {
        paramsList?.filter(i => !i.isHide)?.length > 0 &&
        <div className={`result-panel-params__container ${showParams ? 'open' : 'close'}`} ref={paramsRef}>
          <div className="result-panel-params__content">
            <header className="ocrDemo-result__panel-hd cantOpen">
              <div className="ocrDemo-result-title">
                <span className="ocrDemo-result-title__icon"></span>
                <span className="ocrDemo-result-title__text">{detail?.config?.ArgumentText || '参数调整'}</span>
                <span className="ocrDemo-result-title__reset" onClick={handleResetParams}><span className="ocrDemo-icon ocrDemo-icon_reset"></span>恢复默认</span>
              </div>
              <div className="unv-collapse__panel-collops" onClick={() => {
                setShowParams(!showParams)
              }}></div>
            </header>
            <div className="ocrDemo-result-from-container unv-form unv-form--split" style={{ padding: "0 20px" }}>
              {
                detail.syncConfig &&
                <Form labelAlign="left">
                  <Form.Item className="row" 
                    label={detail.syncConfig.asyncLabel}>
                    <Radio.Group value={apiType} onChange={(e) => {
                      setParamsAndValue(e,true,true);
                    }}>
                  <Radio key="sync" value="sync">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span>快速模型</span>
                      {detail.syncConfig.asyncDes &&
                        <Tooltip content={detail.syncConfig.asyncDes} theme="light">
                          <span className="ocrDemo-icon-question"></span>
                        </Tooltip>
                      }
                    </div>
                  </Radio>
                  <Radio key="async" value="async">稳定模型</Radio>
                </Radio.Group>
                  </Form.Item>
                </Form>
                
              }

              <Form labelAlign={detail?.config?.LabelAlign || 'left'}>
                {
                  paramsList?.filter(i => !i.isHide)?.map((params, index) => {
                    return params.key in paramsValue && <Params
                      clipImg={clipImg}
                      rectOptions={rectOptions}
                      key={params.key}
                      params={
                        {
                          ...params,
                          min: typeof params.min === "string" ? paramsValue[params.min] : params.min || 1,
                          max: totalPage,
                        }
                      }
                      value={paramsValue[params.key]}
                      showClose={params.showClose}
                      onClose={() => {
                        console.log('onClose')
                      }}
                      onSelect={onSelect}
                      onChange={(val, realVal, extra) => {
                        const _paramsValue = {
                          ...paramsValue, [params.key]: val
                        }
                        const _requestVal = {
                          ...paramsValue, [params.key]: realVal || val
                        }
                        setParamsValue(_paramsValue)
                        setRequestParamsValue(_requestVal)
                        onChangeRequest && onChangeRequest(_requestVal)
                        if (extra?.startImmediately && image.isExample) {
                          const defaultImg = cosUrl + extra.defaultImg;
                          onChangeImg && onChangeImg(defaultImg, _requestVal)
                        }
                      }}
                    />
                  })
                }
                {
                  smartKeyList.filter(i => !i.isHide)?.map((params, index) => {
                    return <Params
                      params={{
                        ...params,
                        label: params.label || `字段${index + 1}`,
                        options: params.isCustom ? detail?.options?.map((item, index) => {
                          return {
                            text: item,
                            value: index
                          }
                        }) : params.options
                      }}
                      status={params.status}
                      placeholder={params.placeholder}
                      value={params.value}
                      showClose={params.showClose}
                      onClose={() => handleDelSmart(params, index)}
                      onChange={(val) => {
                        setSmartKeyList(smartKeyList.map(i => {
                          if (i.key === params.key) {
                            return {
                              ...i,
                              value: val,
                              status: reg.test(val) ? 'error' : ''
                            }
                          } else {
                            return i
                          }
                        }));
                      }} />
                  })
                }
                {
                  (detail?.showCustomItem || detail?.resultConfig?.showCustomItem) && <p style={{ marginTop: '8px', marginBottom: '20px' }}>
                    <Button theme="default" variant="outline" disabled={isLoading} onClick={() => handleAddSmart('default')}>
                      <span className="ocrDemo-icon_add"></span>
                      <span>默认key</span>

                    </Button>
                    <Button theme="default" variant="outline" disabled={isLoading} onClick={() => handleAddSmart('custom')} style={{ marginLeft: '20px' }}>
                      <span className="ocrDemo-icon_add"></span>

                      <span>自定义key</span>
                    </Button>
                  </p>
                }
                <div className="message_scroll__bar" style={{ clear: 'both', height: '1px', width: '100%' }} ref={messagesEnd}></div>

              </Form>
            </div>
          </div>
        </div>
      }
      <div className="ocrDemo-result-response-container">
        <Tab className="ocrDemo-result-response__tab" defaultActiveId={curColl} activeId={curColl} onActive={(tab) => setCurColl(tab)}>
          {
            rspTabs.map(item => (
              <Tab.TabItem id={item.id} label={item.label} key={item.id}>
                <RspParams
                  type={item.type}
                  finalResponse={finalResponse}
                  request={request}
                  response={response}
                  isLoading={isLoading || isThinking}
                  isMarkLoading={isMarkLoading}
                  selectRect={selectRect}
                  detail={detail}
                  image={image}
                  onSelect={onSelect}
                  eduMarkData={eduMarkData}
                  rects={rectOptions}
                />
              </Tab.TabItem>
            ))
          }
        </Tab>
        <footer className="unv-collapse__panel__footer">
          <div className="ocrDemo-footer-btn-container">
            {
              detail.showDownBtn && <>
                {
                  request[detail.resultConfig.markdownKey] === 'Mdbase64' &&
                  <Button theme="default" variant="outline" onClick={() => DownloadMd(response[detail.resultConfig.markdownContent], 'md', '结果')}>导出Markdown结果</Button>
                }
                {
                  request[detail.resultConfig.markdownKey] === 'Excelbase64' &&
                  <Button theme="default" variant="outline" onClick={() => DownloadExcel(response[detail.resultConfig.markdownContent], '结果')}>导出Excel结果</Button>
                }
              </>
            }
            {
              (detail.actionType === 'Async' ||  apiType === 'async' || detail.actionType === 'markEdu') ? <div className="ocrDemo-result__btn" onClick={() => {
                if (isThinking || isMarkLoading) {
                  handleStop();
                } else {
                  if (isLoading) return;
                  handleStart({ _params: requestParamsValue })
                }
              }}>
                <div className={`ocrDemo-result__btn_content ${isThinking || isMarkLoading? 'stop' : 'start'}`}></div>
                <div className="ocrDemo-result__btn_border" ></div>
              </div> :
                detail.actionType === 'eduAgent' ? <>
                  <div className="ocrDemo-result__btn" onClick={() => {
                    handleStartEduAgent({ requestParamsValue, clipImg })
                  }}>
                    <div className={`ocrDemo-result__btn_content start`}></div>
                    <div className="ocrDemo-result__btn_border" ></div>
                  </div>
                </> : <div className="ocrDemo-result__btn" onClick={() => handleStart({ _params: requestParamsValue })}>
                  <div className="ocrDemo-result__btn_content"></div>
                  <div className="ocrDemo-result__btn_border" ></div>
                </div>
            }
          </div>
        </footer>
      </div>
    </div>
  );
}